import type { EasingFn } from '@/animation/easing/easingFn'

function clamp01(t: number): number {
  if (t <= 0) return 0
  if (t >= 1) return 1
  return t
}

/** @returns 线性 */
export const linear: EasingFn = (t) => clamp01(t)

/** @returns 三次 ease-in */
export const easeInCubic: EasingFn = (t) => {
  const x = clamp01(t)
  return x * x * x
}

/** @returns 三次 ease-out */
export const easeOutCubic: EasingFn = (t) => {
  const x = clamp01(t)
  const u = 1 - x
  return 1 - u * u * u
}

/** @returns 三次 ease-in-out */
export const easeInOutCubic: EasingFn = (t) => {
  const x = clamp01(t)
  if (x < 0.5) return 4 * x * x * x
  const u = 2 * x - 2
  return 1 + 0.5 * u * u * u
}

/** @returns 末端弹跳（近似 ease-out bounce） */
export const bounceOut: EasingFn = (t) => {
  const x = clamp01(t)
  if (x < 1 / 2.75) return 7.5625 * x * x
  if (x < 2 / 2.75) {
    const u = x - 1.5 / 2.75
    return 7.5625 * u * u + 0.75
  }
  if (x < 2.5 / 2.75) {
    const u = x - 2.25 / 2.75
    return 7.5625 * u * u + 0.9375
  }
  const u = x - 2.625 / 2.75
  return 7.5625 * u * u + 0.984375
}

const BACK_C1 = 1.70158
const BACK_C3 = BACK_C1 + 1

/** @returns 略超出终点再回落（back-out，Robert Penner 形式） */
export const backOut: EasingFn = (t) => {
  const x = clamp01(t)
  const u = x - 1
  return 1 + BACK_C3 * u * u * u + BACK_C1 * u * u
}
